export default __webpack_public_path__ + "static/media/404.633784c2.png";